import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, printVariable} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';
import { findCode } from '@util/helper';
import useDelegate from "@hooks/useDelegate";
import useAlert from "@hooks/useAlert";
import { RefSelector } from 'ag-grid-community';
import AddCircleOutlineOutlined from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined'; 
import ConfirmDialog from '@components/ConfirmDialog';
import { update } from 'lodash';
const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const CalendarManagerPart = ({fields, record, callback, dgRef}) => {
  console.log('CalendarManagerPart rendering...');
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)
  const updateRef = useRef(false)
  const {alert, renderAlert} = useAlert()
  const [holidays, set_holidays] = useState([])
  const [holiday, set_holiday] = useState({dateName:'', locDate:''})
  const recordsRef = useRef([]) 
  const [confirmMsg, set_confirmMsg] = useState('')
	const validate = async (name, value) => {
    let err = ''
    if(name === 'dateName') {
      if(value.trim().length === 0) {
        err = '공휴일명이 입력되지 않았습니다.'
      }
    }
    if(name === 'locDate') {
      const valid = moment(value, "YYYYMMDD", true).isValid()
      if(!valid) {
        err = '날자 형식이 맞지 않습니다.'
      }
    }
    return err
  }

	const { activeRow, errors, updateState, handleChange, handleSubmit, factor } = useDelegate({
		initialValues: { ...holiday},
		validate: validate,
	})

  const fetchHolidays = async() => {
    const url = `/holiday/school/only/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)

    records.sort((a,b) => b.locDate.localeCompare(a.locDate))
    return records
  }

  const onLoad = async() => {
    const records = await fetchHolidays()
    if(records) {
      recordsRef.current = records 
      set_holidays(records)
    }
  }

  useEffect(() => {
    onLoad()
  },[])


  const handleClose = () => {
    dgRef.current.close()
    if(callback){
      callback(updateRef.current)
    }
  }

  const isSameArray = () => {
    if(recordsRef.current.length !== holidays.length) {
      return false
    }
    return recordsRef.current.every(obj1 => {
      const match= holidays.find(obj2 => obj1.dateName === obj2.dateName && obj1.locDate === obj2.locDate)
      return !!match
    })
  }

  const canAdd = () => {
    const errcnt = Object.values(errors).filter(r => r.length > 0).length
    if(errcnt > 0) {
      return false
    }
    if(factor.dateName.trim().length == 0) {
      return false
    }
    if(factor.locDate.trim().length === 0) {
      return false
    }

    return true
  }

  const onPlus = () => {
    const holiday = {
      dateName: factor.dateName,
      locDate: factor.locDate
    }
    
    const found = holidays.find(r => r.dateName === holiday.dateName && r.locDate === holiday.locDate)
    if(found) {
      alert('동일한 공휴일명/날자가 존재합니다.')
      return
    }

    const new_holidays = [...holidays]
    new_holidays.unshift(holiday)
    set_holidays(new_holidays)
    set_holiday()

    factor.dateName = ''
    factor.locDate = ''
    updateState()
  }

  const onMinus = (hday) => {
    const new_holidays = [...holidays]
    const idx = new_holidays.findIndex(r => r.dateName === hday.dateName && r.locDate === hday.locDate) 
    if(idx >= 0) {
      new_holidays.splice(idx, 1)
      set_holidays(new_holidays)
    }
  }

  const preSubmit = async () => {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss'
    const now = moment().format(dateFormat)
    const holidayList = [...holidays]
    for(const d of holidayList) {
      console.log('holiday', JSON.stringify(d, 0,2 ))
      d.id = -1
      d.schoolId = schola.id
      d.uptTime = now
      d.regTime = now
    }

    const url = `/holiday/has/bings/school/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url, holidayList) 
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)

    if(repMessage.confirm?.length > 0) {
      set_confirmMsg(repMessage.confirm + '\n') 
    }
  }

  const onSubmit = async () => {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss'
    const now = moment().format(dateFormat)
    const holidayList = [...holidays]
    for(const d of holidayList) {
      console.log('holiday', JSON.stringify(d, 0,2 ))
      d.id = -1
      d.schoolId = schola.id
      d.uptTime = now
      d.regTime = now
    }

    const url = `/holiday/school/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url, holidayList) 
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    updateRef.current = true
    alert('저장하였습니다.', () => {handleClose()})
  }


  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />

      <div style={{marginTop:10}}>
        <Grid container spacing={2} >
          <Grid item xs={5} >
              <TextField fullWidth label='공휴일명' name={'dateName'} value={activeRow.dateName} 
                onChange={async(e) => handleChange(e, () => updateState())}  
              />
            <FormHelperTexts>{errors["dateName"]}</FormHelperTexts>
          </Grid>
          <Grid item xs={5}>
              <TextField fullWidth label='날자 예) 20201010' name={'locDate'} value={activeRow.locDate}
                onChange={async(e) => handleChange(e, () => updateState())}
              />
              <FormHelperTexts>{errors["locDate"]}</FormHelperTexts>
          </Grid>
          <Grid item xs={2}>
            <IconButton 
              disabled={!canAdd()}
              onClick={onPlus}
            >
              <AddCircleOutlineOutlined/>
            </IconButton>
          </Grid>
        </Grid>
      </div>

      <Divider style={{marginTop:10, marginBottom:10}}/>
      <div style={{minHeight:500, paddingLeft:10}}>
        <Grid container spacing={0}  style={{display:'flex', alignItems:'center'}}>
        {
          holidays.map((hday, idx) => (
            <Fragment key={idx} >
              <Grid item xs={5} >
                {hday.dateName}
              </Grid>
              <Grid item xs={5}>
                {hday.locDate}
              </Grid>
              <Grid item xs={2}>
                  <IconButton 
                    onClick={() => onMinus(hday)}
                  >
                    <RemoveCircleOutlineIcon/>
                  </IconButton>
              </Grid>
            </Fragment> 
          ))
        }
        </Grid>
      </div>
      <div style={{ display: "flex", justifyContent:'center', marginTop:0 }}>
        <Button variant='outlined' color='primary' size='small' onClick={handleClose} sx={{ mt: 5, mr:1 }} >
          닫기
        </Button>
        <ConfirmDialog
            btn={<Button variant='contained' size='small' color={'primary'} sx={{ mt: 5, mr:1 }} >저장</Button>}
            title={'알림'}
            content={`${confirmMsg}공휴일을 저장하시겠습니까?`}
            bc={'primary'}
            preHandle={ async () => {
              if(isSameArray()) {
                alert('변동된 공휴일 데이터가 없습니다.')
                return false
              }
              else {
                await preSubmit()
                return true
              }
            }}
            perform={() => {
              onSubmit() 
            }}
        />
      </div>
    {renderSnackbar()}
    {renderIndicator()}
    {renderAlert()}
  </Container>
  );
  
}

export default CalendarManagerPart
